import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from 'uuid';

const initialState = {
    dbCarregadoComSucesso : false,
    busca: "",
    statusText: "",
    data : [],
    fileVersion : 0,
    tags : ["NAO CONCLUIDA"],
    ordem : "DATA_DESC",
    edicaoError: null,
    notaEmEdicao : null,
    encryptKey: null,
    processando : false,
    redirectAfter: false,
}

export const notetakerSlice = createSlice({
    name: "notetaker",
    initialState,
    reducers: {
        setEncryptKey: (state, action) => {
            state.encryptKey = action.payload
        },
        triggerCarregaDB : () => {},
        defineCarregadoComSucesso : (state, action) => {
            state.dbCarregadoComSucesso = action.payload
        },
        defineAttr : (state, action) => {
            state[action.payload.campo] = action.payload.value
        },
        definirNotaEmEdicao : (state, action) => {
            state.notaEmEdicao = action.payload
        },
        triggerSalvarNota: () => {},
        salvarNota : (state, action) => {
            var n = [...state.data]

            var filtered = n.filter( e => e.id == action.payload.id)

            if(filtered.length != 0) {
                n.splice(n.indexOf(filtered[0]), 1)
            } 

            n.push(action.payload)

            // precisa atualizar se ja existir

            if(state.ordem == "DATA_DESC") {
                n.sort((a,b) => a.dataCriacao > b.dataCriacao ? -1 : 1)
            }

            state.data = n

        },
        atualizaCampoEmEndicao : (state, action) => {
            state.notaEmEdicao[action.payload.campo] = action.payload.value
        },
        atualizaStateCampo : (state, action) => {
            state[action.payload.campo] = action.payload.value
        }
    }
})

export function notaVazia() {
    return {
        id : uuidv4(),
        titulo : "",
        conteudo : "",
        dataCriacao : new Date().toString(),
        tags : []
    }
}

export const {
    setEncryptKey,
    triggerCarregaDB,
    defineCarregadoComSucesso,
    defineAttr,
    definirNotaEmEdicao,
    salvarNota,
    atualizaCampoEmEndicao,
    triggerSalvarNota,
    atualizaStateCampo
} = notetakerSlice.actions;


export default notetakerSlice.reducer;